<template>
    <div class="list_box">
        <div class="list_hd">
            <a :href="cruiseLink">{{cruise.cruiseName}}</a>
        </div>
        <div class="list_bd fix">
            <div class="f-fl">
                <div class="img_box">
                    <img :src="cruise.pcImage">
                </div>
            </div>
            <div class="f-fr">
                <div class="info_box">{{cruise.routeDays}}天{{cruise.routeDays-1}}晚 {{cruise.shipCNName}}</div>
                <div class="time_box">{{cruise.sailDateBegin}} - {{cruise.sailDateEnd}}</div>
                <div class="price_box" v-if="cruise.netAmount > 0">
                    {{priceType}}<span><em>￥</em>{{cruise.netAmount}}</span>/人起<br>
                    <div>平均每晚￥{{cruise.amountPerNight}}/人起</div>
                </div>
                <div class="price_box" v-else>
                    售罄
                </div>
                <div class="tool_box">
                    <a :href="cruiseSearchLink" class="tool_btn find_btn" target="_blank">
                        <i class="detail_ico_18 find_ico"></i>找相似
                    </a>
                    <a class="tool_btn delete_btn" @click="onWishListDelete(cruise.cruiseId)">
                        <i class="detail_ico_18 delete_ico"></i>删除
                    </a>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import nrpConfig from '@/utilities/nrpConfig'
export default {
    name: "WishListFloatItem",
    props: {
        cruise: {
            type: Object
        },
        onWishListDelete: {
            type: Function
        }
    },
    computed: {
        cruiseLink () {
            if (this.cruise.isRow) {
                return process.env.VUE_APP_TUI_URL + `/Cruise/CruiseDetail?sailDate=${this.cruise.sailDate}&shipCode=${this.cruise.shipCode}`
            } else {
                return `/Rccl.Cruise/CruiseDetail?sailDate=${this.cruise.sailDate}&shipCode=${this.cruise.shipCode}`
            }
        },
        priceType () {
            if (this.cruise.isFortyEightHoursNrpCruise) {
                return nrpConfig.fortyEightHoursNrp.priceType
            } else if (this.cruise.isnrpPrice) {
                return nrpConfig.nrp.priceType
            } else {
                return nrpConfig.rp.priceType
            }
        },
        cruiseSearchLink () {
            const isRow = this.cruise.isRow;
            let cruiseSearchLink = '/Rccl.Cruise/CruiseSearch/Search?';
            if (isRow) {
                cruiseSearchLink = process.env.VUE_APP_TUI_URL + '/Cruise/Search?';
            }

            let portCodes = [];
            let departureCodes = ""
            const routeEvents = this.cruise.routeEvents;
            if (routeEvents != null) {
                for (var x = 0; x < routeEvents.length; x++) {
                    if (routeEvents[x].day == 1) {
                        departureCodes = routeEvents[x].harborCode
                    } else if (routeEvents[x].activity != "CRUISING" && routeEvents[x].day < this.cruise.routeDays) {
                        portCodes.push(routeEvents[x].harborCode)
                    }
                }
            }
            cruiseSearchLink += `destinationCodes=${encodeURIComponent(portCodes.join(','))}&departureCodes=${departureCodes}`
                + `&shipCodes=${this.cruise.shipCode}`;

            return cruiseSearchLink;
        }
    }
}
</script>

<style lang="less" scoped>


.list_box {
    padding: 7px 10px;
    background: white;
    .list_hd {
        color: #006ab9;
        font-weight: bold;
        line-height: 1.8;
        margin-bottom: 2px;
    }
    .list_bd {
        .f-fl {
            width: 39%;
            .img_box img {
                width: 100%;
            }
        }
        .f-fr {
            width: 58%;
            color: #747d80;
            .info_box {
                margin-bottom: 2px;
                white-space: nowrap;
                overflow: hidden;
                text-overflow: ellipsis;
            }
            .time_box {
                color: #282b2c;
                margin-bottom: 1px;
            }
            .price_box {
                margin-bottom: 5px;
                span {
                    font-size: 16px;
                    color: #ff3022;
                    em {
                        font-size: 12px;
                        font-style: normal;
                    }
                }
            }
            .tool_box {
                .tool_btn {
                    display: inline-block;
                    margin-right: 10px;
                    cursor: pointer;
                }
                .delete_btn {
                    color: #747d80;
                }
            }
        }
    }
}


</style>